import * as React from "react";
import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { DropDownButton } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";

import styles from "./Casefile.module.scss";
import { getClientData, getClientLoginAccess, getMatterAllInfo } from "api";
import { getMattersAllURLInfo } from "actions/matters.action";

import CaseActivitiesPage from "./CaseActivities/CaseActivitiesPage";
import MatterLedgerCardPage from "pages/Matters/MattersLedgerCardPage";
import CaseContactsPage from "../CaseFile/CaseContactsPage";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import CaseWorkFlows from "./CaseWorkFlow/CaseWorkFlow";
import TimeRecorded from "components/Time/TimeRecorded";
import MatterForm from "pages/Matters/MatterForm";
import AddClients from "pages/Clients/AddViewClients";
import BillingGuideModal from "./BillingGuideModal";
import EmailCompletion from "components/common/EmailComposition";
import CaseTasks from "./CaseTasks";
import useFilterState from "../../components/CaseFiles/useFilterState";
import EmailDialog from "components/common/EmailComposition/EmailDialog";
import ChitRequest from "pages/ChitRequest/ChitRequest";
import ExpenseRequest from "pages/ExpenseRequest/ExpenseRequest";
import { ClientServices } from "./ClientServices";
import { useCompany } from "services/companyService";
import SearchTextBox from "components/SearchComponent";
import { DateFormat } from "components/common/formatter";
import {
  useAccessRight,
  CaseAccessRights,
} from "../../components/UserAccessRights.ts";

/*** IMPORT ICONS*/
import { arrowRotateCwIcon as refreshIcon } from "@progress/kendo-svg-icons";
import MatterIcon from "../../assets/CaseFileIcons/matter.svg";

import ClientIcon from "../../assets/CaseFileIcons/client.svg";
import mail from "../../assets/CaseFileIcons/newEmail.svg";
import filtersAppliedIcon from "../../assets/CaseFileIcons/FilterApplied.svg";
import ChitRequestIcon from "../../assets/CaseFileIcons/chit-request.svg";
import billingIcon from "../../assets/CaseFileIcons/billingGuide.svg";
import ExpenseRequestIcon from "../../assets/CaseFileIcons/expense-request.svg";
import ConflictCheckImage from "../../assets/CaseFileIcons/conflict-check.svg";
import ClientDropDown from "../../assets/CaseFileIcons/app-bar/client.svg";
import ChitRequestDropDown from "../../assets/CaseFileIcons/app-bar/chit-request.svg";
import BillingRequestIcon from "../../assets/CaseFileIcons/billing-request.svg";
import BillingRequestDropDown from "../../assets/CaseFileIcons/app-bar/billing-request.svg";
import ConflictCheckDropDown from "../../assets/CaseFileIcons/app-bar/conflict-check.svg";
import BillingGuideDropDown from "../../assets/CaseFileIcons/app-bar/billing-guide.svg";
import ExpenseRequestDropDown from "../../assets/CaseFileIcons/app-bar/expense-request.svg";
import EmailDropDown from "../../assets/CaseFileIcons/app-bar/email.svg";
import MatterDropdown from "../../assets/CaseFileIcons/app-bar/matter.svg";
import TimeRecordingIcon from "../../assets/CaseFileIcons/add-time.svg";
import TimeRecordingDropDown from "../../assets/CaseFileIcons/app-bar/add-time.svg";
import { MdArrowDropDown } from "react-icons/md";
import { FaFilter } from "react-icons/fa";
import ConflictCheck from "./ConflictCheck";
import { ClientIdVerification } from "./ClientServices/ClientServicesTasks/IdVerification";
import BillingRequestModal from "pages/Bills/BillingRequestModal";
import { changeClientEditPermission } from "actions/clients.action";
import LoadingScreen from "components/common/Loading";
import AddTime from "pages/Time/AddTime";

const ALL_TABS = [
  "Activities",
  "Time Recording",
  "Tasks",
  "Work Flows",
  "Client Services",
  "Contacts",
  "Ledger Card",
];

const CASE_FILE_TAB_BY_QUERY = { ledger: "Ledger Card" };

const TAB = {
  ACTIVITIES: "Activities",
  TIME: "Time Recording",
  TASKS: "Tasks",
  WORKFLOWS: "Work Flows",
  CLIENT_SERVICES: "Client Services",
  CONTACTS: "Contacts",
  LEDGER: "Ledger Card",
};

const itemRender = (props) => {
  return (
    <div className="flex items-center mt-1 gap-2">
      {props.item.icon && (
        <img
          src={props.item.icon}
          className="k-mr-3 flex-shrink-0"
          style={{ width: "18px", height: "18px" }}
          alt="item icon"
        />
      )}
      <span className="flex-grow">{props.item.text}</span>
    </div>
  );
};

const CaseFileView = (props) => {
  const { data: company } = useCompany();
  const isClientServicesEnabled = Boolean(company?.modules?.ClientServices);
  const options = isClientServicesEnabled
    ? ALL_TABS
    : ALL_TABS.filter((tab) => tab !== "Client Services");
  const [currentMatterDetails, setcurrentMatterDetails] = useState([]);
  const [billingRequestMatter, setBillingRequestMatter] = useState(false);
  const [searchParams] = useSearchParams();
  const [activeItem, setActiveItem] = useState(0);
 
  const activeTabName = options[activeItem];
  const [addActivity, setAddActivity] = useState(false);
  const [attachContact, setAttachContact] = useState(false);
  const [reference, setReference] = useState();
  const [openEmailCompletion, setOpenEmailCompletion] = useState(false);
  const [openExistingEmailCompletion, setOpenExistingEmailCompletion] = useState();
  const [editData, setEditData] = useState({});
  const [showClientForm, setShowClientForm] = useState(false);
  const [addTime, setAddTime] = useState(false);
  const [caseFileAddTimeOpen, setCaseFileAddTimeOpen] = useState(false);
  const [addTask, setAddTask] = useState(false);
  const [showScreens, setShowScreens] = useState(false);
  const [showMatterForm, setshowMatterForm] = useState(false);
  const [editWorkflow, setEditWorkflow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [refreshFlags, setRefreshFlags] = useState({});
  const setTabRefresh = useCallback((tabName, value) => {
    setRefreshFlags((prev) => {
      const next = typeof value === "function" ? value(prev[tabName]) : value;
      return prev[tabName] === next ? prev : { ...prev, [tabName]: next };
    });
  }, []);
  const requestTabRefresh = useCallback(
    (tabName) => setTabRefresh(tabName, true),
    [setTabRefresh],
  );
  const [showBillingGuide, setShowBillingGuide] = useState(false);
  const [showExpenseRequest, setShowExpenseRequest] = useState(false);
  const [showChitRequest, setShowChitRequest] = useState(false);
  const [showConflictCheck, setShowConflictCheck] = useState(false);
  const [clientTask, setClientTask] = useState();
  const [activitySearch, setActivitySearch] = useState("");
  const [workflowSearch, setWorkflowSearch] = useState("");
  const workflowSearchRef = useRef(null);
  const searchRef = useRef();

  const filterAnchorRef = useRef(null);
  const filterContentRef = useRef(null);

  const activitiesFilterState = useFilterState();
  const timeRecordingFilterState = useFilterState();
  const tasksFilterState = useFilterState();
  const [isAddActivityBtn, setIsAddActivityBtn] = useState(false);
  const [showClientModal, setClientModal] = useState(false);
  const [clientModalMode, setClientModalMode] = useState("view");
  const canEditWorkflow = useAccessRight(CaseAccessRights.EditWorkFlow);

  useEffect(() => {
    async function getMatterInfo() {
      const datas = await getMatterAllInfo(props?.id);
      setcurrentMatterDetails(datas?.data?.data);
    }
    getMatterInfo();
  }, [props?.id]);

  useEffect(() => {
    const tabQuery = searchParams.get("tab")?.toLowerCase();
    const tabName = tabQuery && CASE_FILE_TAB_BY_QUERY[tabQuery];
    if (!tabName) return;
    const tabIndex = options.indexOf(tabName);
    if (tabIndex >= 0) setActiveItem(tabIndex);
  }, [searchParams, props?.id]);

  useEffect(() => {
    if (!addTime) return;
    setCaseFileAddTimeOpen(true);
    setAddTime(false);
  }, [addTime]);

  const handleSearchChange = (value) => {
    setActivitySearch(value);
  };

  const handleWorkflowSearchChange = (value) => {
    setWorkflowSearch(value || "");
  };

  const clientsDataGetter = async (id) => {
    try {
      setIsLoading(true);
      const data = await getClientData(id);
      setEditData(data?.data?.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      navigate("/clients");
    }
  };

  const navigateToClientPortal = async (id) => {
    try {
      setIsLoading(true);
      const response = await getClientLoginAccess(
        currentMatterDetails?.clientId,
        currentMatterDetails?.matterId,
      );

      // Assuming the URL is in response.data.url
      const clientPortalUrl = response.data;

      if (clientPortalUrl) {
        window.open(clientPortalUrl, "_blank"); // Open the URL in a new tab
      } else {
        toast.error("Invalid URL received from the server.");
      }
      setIsLoading(false); // Stop loading after navigation
    } catch (error) {
      setIsLoading(false);
    }
  };

  const onClientRefClickActions = () => {
    clientsDataGetter(currentMatterDetails?.clientId);
    setClientModal(true);
  };

  const mattersDataGetter = async (id) => {
    try {
      dispatch(getMattersAllURLInfo(currentMatterDetails, false));
    } catch (error) {
      navigate("/matters");
    }
  };

  const onMatterRefClickActions = (props) => {
    setReference(currentMatterDetails?.matterRef);
    mattersDataGetter(currentMatterDetails?.matterId);
    setshowMatterForm(true);
  };

  const actionButtonItems = [
    {
      text: "Add Time",
      icon: TimeRecordingDropDown,
      action: () => setAddTime(true),
    },
    { text: "Client", icon: ClientDropDown, action: onClientRefClickActions },
    { text: "Matter", icon: MatterDropdown, action: onMatterRefClickActions },
    {
      text: "Conflict Check",
      icon: ConflictCheckDropDown,
      action: () => setShowConflictCheck(true),
    },
    {
      text: "Billing Guide",
      icon: BillingGuideDropDown,
      action: () => setShowBillingGuide(true),
    },
    {
      text: "Chit Request",
      icon: ChitRequestDropDown,
      action: () => setShowChitRequest(true),
    },
    {
      text: "Expense Request",
      icon: ExpenseRequestDropDown,
      action: () => setShowExpenseRequest(true),
    },
    {
      text: "Billing Request",
      icon: BillingRequestDropDown,
      action: () => setBillingRequestMatter(currentMatterDetails),
    },
    {
      text: "Email",
      icon: EmailDropDown,
      action: () => setOpenEmailCompletion(true),
    },
  ];

  const servicesButtonItems = [
    { text: "Data Collection Form", action: () => setShowScreens(true) },
    { text: "Data Collection File" },
    { text: "ID Verification", action: () => setClientTask("ID-Verification") },
    { text: "Request Documents" },
    { text: "Sign Documents" },
    { text: "Funds on Account" },
  ];

  const headerIcons = [
    {
      title: "Add Time",
      src: TimeRecordingIcon,
      alt: "Add Time Icon",
      width: 19,
      height: 19,
      onClick: () => setAddTime(true),
    },
    {
      title: "Email",
      src: mail,
      alt: "Email Icon",
      width: 18,
      height: 18,
      onClick: () => setOpenEmailCompletion(true),
    },
    {
      title: "Chit Request",
      src: ChitRequestIcon,
      alt: "Chit Request Icon",
      width: 18,
      height: 18,
      onClick: () => setShowChitRequest(true),
    },
    {
      title: "Billing Request",
      src: BillingRequestIcon,
      alt: "Billing Request Icon",
      width: 18,
      height: 18,
      onClick: () => setBillingRequestMatter(currentMatterDetails),
    },
    {
      title: "Billing Guide",
      src: billingIcon,
      alt: "Billing Guide Icon",
      width: 18,
      height: 18,
      onClick: () => setShowBillingGuide(true),
    },
    {
      title: "Expense Request",
      src: ExpenseRequestIcon,
      alt: "Expense Request Icon",
      width: 18,
      height: 18,
      onClick: () => setShowExpenseRequest(true),
    },
    {
      title: "Conflict Check",
      src: ConflictCheckImage,
      alt: "Conflict Check Icon",
      width: 18,
      height: 18,
      onClick: () => setShowConflictCheck(true),
    },
    {
      title: "Matter",
      src: MatterIcon,
      alt: "Matter Icon",
      width: 18,
      height: 18,
      onClick: () => onMatterRefClickActions(),
    },
    {
      title: "Client",
      src: ClientIcon,
      alt: "Client Icon",
      width: 20,
      height: 20,
      onClick: () => onClientRefClickActions(),
    },
  ];

  return (
    <div
      className={`page h-100 d-flex flex-column ${props.isStandAlone ? "pt-1" : ""}`}>
      <div id="CaseFileHeader" className="mb-3">
        <div
          className={`${styles.legalProceeding} 
                    ${currentMatterDetails?.closed ? styles.closedMatter : ""} 
                    w-100 align-items-center d-flex justify-content-between px-4`}>
          <div className={`${styles["sub-text"]}`}>
            {!props.isStandAlone && (
              <>
                {currentMatterDetails?.client?.clientName} -{" "}
                <u>{currentMatterDetails?.matterRef}</u> -{" "}
                <b className={`${styles.headerMatterDetails} `}>
                  {currentMatterDetails?.details}{" "}
                </b>
                {currentMatterDetails?.appCode && (
                  <span> - [{currentMatterDetails?.appCode}]</span>
                )}
                {currentMatterDetails?.closed && (
                  <span className={`fs-md ${styles.closedMatterText}`}>
                    {" "}
                    - Case Closed
                    {currentMatterDetails?.dateClosed && (
                      <span> on {DateFormat(currentMatterDetails.dateClosed)}</span>
                    )}
                    {currentMatterDetails?.closedByUserRef && (
                      <span> by '{currentMatterDetails?.closedByUserRef}'</span>
                    )}
                  </span>
                )}
              </>
            )}
          </div>

          <div className="d-flex align-items-center gap-3">
            {headerIcons.map((icon) => (
              <Tooltip
                key={icon.title}
                anchorElement="target"
                position="top"
                parentTitle>
                <span title={icon.title} className="d-inline-flex">
                  <Button
                    onClick={icon.onClick}
                    look="flat"
                    className={`${styles["image-block"]} d-flex align-items-center justify-content-center p-0`}>
                    <img
                      src={icon.src}
                      alt={icon.alt}
                      width={icon.width}
                      height={icon.height}
                      style={icon.style}
                    />
                  </Button>
                </span>
              </Tooltip>
            ))}

            <DropDownButton
              text="Actions"
              items={actionButtonItems}
              popupSettings={{ animate: false, popupClass: styles["popup"] }}
              itemRender={itemRender}
              onItemClick={(e) => e.item.action?.()}
            />
          </div>
        </div>
      </div>

      <div className="case-files-tab flex-grow-1 overflow-auto">
        <div className="position-relative h-100 w-100">
          <div className={`d-flex ${styles["casefile-tab-actions"]}`}>
            {activeTabName === TAB.ACTIVITIES && (
              <>
                <div className={styles["casefile-search"]}>
                  <SearchTextBox
                    width="100%"
                    height={"35px"}
                    ref={searchRef}
                    changeFilterValue={handleSearchChange}
                  />
                </div>
                <Tooltip anchorElement="target" position="bottom" parentTitle>
                  <span
                    ref={filterAnchorRef}
                    title="Filters"
                    className="d-inline-flex"
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                      activitiesFilterState.setFilterClicked(
                        !activitiesFilterState.filterClicked,
                      )
                    }
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      activitiesFilterState.setFilterClicked(
                        !activitiesFilterState.filterClicked,
                      )
                    }>
                    {!activitiesFilterState.filterApplied ? (
                      <Button
                        className={`${styles["commonButtonStyle"]} common-btn mx-2 p-2`}>
                        <FaFilter color="white" size={16} />
                      </Button>
                    ) : (
                      <Button
                        className={`${styles["commonButtonStyle"]} common-btn mx-2 p-2`}>
                        <img
                          src={filtersAppliedIcon}
                          alt="Filters Applied"
                          width={25}
                          height={25}
                        />
                      </Button>
                    )}
                  </span>
                </Tooltip>
                <Tooltip anchorElement="target" position="bottom" parentTitle>
                  <span title="Refresh" className="d-inline-flex">
                    <Button
                      className={`${styles["commonButtonStyle"]} common-btn me-2`}
                      svgIcon={refreshIcon}
                      style={{ zIndex: "100" }}
                      onClick={() => {
                        requestTabRefresh(options[activeItem]);
                      }}></Button>
                  </span>
                </Tooltip>
                <Button
                  style={{
                    width: "100px",
                    minWidth: "100px",
                    height: "35px",
                    zIndex: "100",
                  }}
                  className="common-btn"
                  onClick={() => {
                    setAddActivity(true);
                    setIsAddActivityBtn(true);
                  }}>
                  Add Activity
                </Button>
              </>
            )}

            {activeTabName === TAB.TIME && (
              <>
                <Tooltip anchorElement="target" position="bottom" parentTitle>
                  <span
                    ref={filterAnchorRef}
                    title="Filters"
                    className="d-inline-flex"
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                      timeRecordingFilterState.setFilterClicked(
                        !timeRecordingFilterState.filterClicked,
                      )
                    }
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      timeRecordingFilterState.setFilterClicked(
                        !timeRecordingFilterState.filterClicked,
                      )
                    }>
                    {!timeRecordingFilterState.filterApplied ? (
                      <Button
                        className={`${styles["commonButtonStyle"]} common-btn me-2 p-2`}>
                        <FaFilter color="white" size={16} />
                      </Button>
                    ) : (
                      <Button
                        className={`${styles["commonButtonStyle"]} common-btn me-2 p-2`}>
                        <img
                          src={filtersAppliedIcon}
                          alt="Filters Applied"
                          width={25}
                          height={25}
                        />
                      </Button>
                    )}
                  </span>
                </Tooltip>
                <Tooltip anchorElement="target" position="bottom" parentTitle>
                  <span title="Refresh" className="d-inline-flex">
                    <Button
                      className={`${styles["commonButtonStyle"]} common-btn me-2`}
                      svgIcon={refreshIcon}
                      onClick={() => {
                        requestTabRefresh(options[activeItem]);
                      }}></Button>
                  </span>
                </Tooltip>

                <Button
                  style={{
                    width: "100px",
                    minWidth: "100px",
                    height: "35px",
                    zIndex: "100",
                  }}
                  className="common-btn"
                  onClick={() => setAddTime(true)}>
                  Add Time
                </Button>
              </>
            )}

            {activeTabName === TAB.TASKS && (
              <>
                <Tooltip anchorElement="target" position="bottom" parentTitle>
                  <span
                    ref={filterAnchorRef}
                    title="Filters"
                    className="d-inline-flex"
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                      tasksFilterState.setFilterClicked(
                        !tasksFilterState.filterClicked,
                      )
                    }
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      tasksFilterState.setFilterClicked(
                        !tasksFilterState.filterClicked,
                      )
                    }>
                    {!tasksFilterState.filterApplied ? (
                      <Button
                        className={`${styles["commonButtonStyle"]} common-btn me-2 p-2`}>
                        <FaFilter color="white" size={16} />
                      </Button>
                    ) : (
                      <Button
                        className={`${styles["commonButtonStyle"]} common-btn me-2 p-2`}>
                        <img
                          src={filtersAppliedIcon}
                          alt="Filters Applied"
                          width={25}
                          height={25}
                        />
                      </Button>
                    )}
                  </span>
                </Tooltip>
                <Tooltip anchorElement="target" position="bottom" parentTitle>
                  <span title="Refresh" className="d-inline-flex">
                    <Button
                      className={`${styles["commonButtonStyle"]} common-btn me-2 `}
                      svgIcon={refreshIcon}
                      onClick={() => {
                        requestTabRefresh(options[activeItem]);
                      }}></Button>
                  </span>
                </Tooltip>

                <Button
                  style={{
                    width: "100px",
                    minWidth: "100px",
                    height: "35px",
                    zIndex: "100",
                  }}
                  className="common-btn"
                  onClick={() => setAddTask(true)}>
                  Add Task
                </Button>
              </>
            )}

            {activeTabName === TAB.WORKFLOWS && (
              <>
                <div className={`${styles["casefile-search"]} me-2`}>
                  <SearchTextBox
                    width="100%"
                    height={"35px"}
                    ref={workflowSearchRef}
                    changeFilterValue={handleWorkflowSearchChange}
                  />
                </div>
                <div className="d-flex align-items-center">
                  <Tooltip anchorElement="target" position="bottom" parentTitle>
                    <span title="Refresh" className="d-inline-flex">
                      <Button
                        className={`${styles["commonButtonStyle"]} common-btn me-2 `}
                        svgIcon={refreshIcon}
                        onClick={() => {
                          requestTabRefresh(options[activeItem]);
                        }}></Button>
                    </span>
                  </Tooltip>
                  {canEditWorkflow && (
                    <Button
                      className={`${styles["wideButtonStyle"]} common-btn `}
                      onClick={() => setEditWorkflow(!editWorkflow)}>
                      {editWorkflow ? "Exit Edit Mode" : "Edit Workflow"}
                    </Button>
                  )}
                </div>
              </>
            )}

            {activeTabName === TAB.CLIENT_SERVICES && (
              <div className="d-flex align-items-center">
                <Button
                  style={{
                    width: "65px",
                    minWidth: "65px",
                    height: "35px",
                    zIndex: "100",
                  }}
                  className="common-btn me-2"
                  onClick={() => navigateToClientPortal()}
                  disabled={isLoading}>
                  Portal
                </Button>

                <DropDownButton
                  text={
                    <>
                      <span className="ms-2 pt-1">Add Task </span>
                      <MdArrowDropDown size={22} style={{ marginBottom: "2px" }} />
                    </>
                  }
                  items={servicesButtonItems.map((item) => ({
                    ...item,
                    disabled: !item.action,
                  }))}
                  popupSettings={{
                    animate: false,
                    popupClass: `${styles["popup"]} me-4`,
                  }}
                  buttonClass={`${styles["button-overlay"]} common-btn px-2`}
                  style={{ height: "35px" }}
                  itemRender={itemRender}
                  onItemClick={(e) =>
                    servicesButtonItems
                      .filter((item) => item.text === e.item.text)[0]
                      ?.action()
                  }
                />
              </div>
            )}

            {activeTabName === TAB.CONTACTS && (
              <div className="d-flex align-items-center">
                <Tooltip anchorElement="target" position="bottom" parentTitle>
                  <span title="Refresh" className="d-inline-flex">
                    <Button
                      className={`${styles["commonButtonStyle"]} common-btn me-2`}
                      svgIcon={refreshIcon}
                      onClick={() => {
                        requestTabRefresh(options[activeItem]);
                      }}></Button>
                  </span>
                </Tooltip>

                <Button
                  className={`${styles["wideButtonStyle"]} common-btn `}
                  onClick={() => setAttachContact(true)}>
                  Attach Contact
                </Button>
              </div>
            )}

            {activeTabName === TAB.LEDGER && (
              <div className="d-flex align-items-center">
                <Tooltip anchorElement="target" position="bottom" parentTitle>
                  <span title="Refresh" className="d-inline-flex">
                    <Button
                      className={`${styles["commonButtonStyle"]} common-btn me-2`}
                      svgIcon={refreshIcon}
                      onClick={() => {
                        requestTabRefresh(options[activeItem]);
                      }}></Button>
                  </span>
                </Tooltip>
              </div>
            )}
          </div>

          <TabStrip
            scrollable={true}
            onSelect={(e) => setActiveItem(e.selected)}
            keepTabsMounted={true}
            selected={activeItem}
            className="pagetab case-files-tabtitle-width h-100 w-100">
            {options.map((item) => {
              return (
                <TabStripTab
                  title={
                    <PageTabItemTitle
                      title={item}
                      index={options.indexOf(item)}
                      selected={activeItem}
                    />
                  }
                  key={item}
                  contentClassName="h-100 mt-3">
                  {item === "Activities" && (
                    <CaseActivitiesPage
                      searchValue={activitySearch}
                      filterAnchor={filterAnchorRef}
                      filterContentRef={filterContentRef}
                      filterClicked={activitiesFilterState.filterClicked}
                      setFilterClicked={activitiesFilterState.setFilterClicked}
                      setFilterApplied={activitiesFilterState.setFilterApplied}
                      filterApplied={activitiesFilterState.filterApplied}
                      addActivity={addActivity}
                      refreshClicked={Boolean(refreshFlags[TAB.ACTIVITIES])}
                      setRefreshClicked={(value) =>
                        setTabRefresh(TAB.ACTIVITIES, value)
                      }
                      activeItem={activeItem}
                      setAddActivity={(value) => {
                        setAddActivity(value);
                        if (!value) {
                          setIsAddActivityBtn(false);
                        }
                      }}
                      addFormText={
                        currentMatterDetails?.matterRef +
                        "-" +
                        currentMatterDetails?.details
                      }
                      matterId={props?.id}
                      matterDetails={currentMatterDetails}
                      isAddActivityBtn={isAddActivityBtn}
                    />
                  )}

                  {item === "Time Recording" && (
                    <TimeRecorded
                      {...props}
                      filterAnchor={filterAnchorRef}
                      filterContentRef={filterContentRef}
                      setFilterApplied={timeRecordingFilterState.setFilterApplied}
                      filterApplied={timeRecordingFilterState.filterApplied}
                      refreshClicked={Boolean(refreshFlags[TAB.TIME])}
                      setRefreshClicked={(value) => setTabRefresh(TAB.TIME, value)}
                      filterClicked={timeRecordingFilterState.filterClicked}
                      setFilterClicked={timeRecordingFilterState.setFilterClicked}
                      activeItem={activeItem}
                      fromCaseFile={true}
                      selectedMatterId={currentMatterDetails?.matterId}
                      matter={currentMatterDetails}
                    />
                  )}
                  {item === "Tasks" && (
                    <CaseTasks
                      filterAnchor={filterAnchorRef}
                      filterContentRef={filterContentRef}
                      filterClicked={tasksFilterState.filterClicked}
                      setFilterClicked={tasksFilterState.setFilterClicked}
                      setFilterApplied={tasksFilterState.setFilterApplied}
                      filterApplied={tasksFilterState.filterApplied}
                      addTask={addTask}
                      addFormText={
                        currentMatterDetails?.matterRef +
                        "-" +
                        currentMatterDetails?.details
                      }
                      refreshClicked={Boolean(refreshFlags[TAB.TASKS])}
                      setRefreshClicked={(value) => setTabRefresh(TAB.TASKS, value)}
                      activeItem={activeItem}
                      setAddTask={(value) => setAddTask(value)}
                      matterId={currentMatterDetails?.matterId}
                      matterDetails={currentMatterDetails}
                    />
                  )}
                  {item === "Work Flows" && (
                    <CaseWorkFlows
                      editWorkflow={editWorkflow}
                      selTab={props.selTab}
                      reference={currentMatterDetails}
                      matterId={currentMatterDetails?.matterId}
                      searchValue={workflowSearch}
                      onClearSearch={() => {
                        workflowSearchRef.current?.clearSearch?.();
                        setWorkflowSearch("");
                      }}
                      refreshClicked={Boolean(refreshFlags[TAB.WORKFLOWS])}
                      setRefreshClicked={(value) =>
                        setTabRefresh(TAB.WORKFLOWS, value)
                      }
                      activeItem={activeItem}
                    />
                  )}
                  {item === "Client Services" && (
                    <div className="h-100">
                      <ClientServices
                        matter={currentMatterDetails}
                        showScreens={showScreens}
                        setShowScreens={setShowScreens}
                      />
                    </div>
                  )}
                  {item === "Contacts" && (
                    <CaseContactsPage
                      refreshClicked={Boolean(refreshFlags[TAB.CONTACTS])}
                      setRefreshClicked={(value) =>
                        setTabRefresh(TAB.CONTACTS, value)
                      }
                      activeItem={activeItem}
                      attachContact={attachContact}
                      setAttachContact={(value) => setAttachContact(value)}
                      matterId={currentMatterDetails?.matterId}
                    />
                  )}
                  {item === "Ledger Card" && (
                    <div className="h-100">
                      <MatterLedgerCardPage
                        selTab={props.selTab}
                        reference={currentMatterDetails?.matterId}
                        refreshClicked={Boolean(refreshFlags[TAB.LEDGER])}
                        setRefreshClicked={(value) =>
                          setTabRefresh(TAB.LEDGER, value)
                        }
                        activeItem={activeItem}
                        fromCaseFile={true}
                        matterDetails={currentMatterDetails}
                      />
                    </div>
                  )}
                </TabStripTab>
              );
            })}
          </TabStrip>
        </div>
      </div>

      <>
        {caseFileAddTimeOpen && (
          <Dialog
            title="Add Time"
            className="dialog-md"
            onClose={() => setCaseFileAddTimeOpen(false)}>
            <AddTime
              component="modal"
              fromCaseFile={true}
              showModal={() => setCaseFileAddTimeOpen(false)}
              mode="add"
              initialData={currentMatterDetails}
              matter={currentMatterDetails}
              cancelEdit={() => setCaseFileAddTimeOpen(false)}
              fetchTime={() => requestTabRefresh(TAB.TIME)}
            />
          </Dialog>
        )}

        {showChitRequest && (
          <ChitRequest
            cancelEdit={() => {
              setShowChitRequest(false);
            }}
            component={"modal"}
            setModal={setShowChitRequest}
            matter={currentMatterDetails}
            matterId={currentMatterDetails?.matterId}
            viewMode="dialog"
          />
        )}

        {showExpenseRequest && (
          <ExpenseRequest
            matter={currentMatterDetails}
            cancelEdit={() => setShowExpenseRequest(false)}
            onSubmitSuccess={() => requestTabRefresh(TAB.ACTIVITIES)}
          />
        )}

        {showMatterForm && (
          <MatterForm
            isView={reference !== undefined}
            reference={reference}
            onMatterRefClickActions={onMatterRefClickActions}
            setshowMatterForm={() => {
              setshowMatterForm(false);
              setReference(undefined);
            }}
          />
        )}
        {showClientModal && (
          <Dialog
            title={clientModalMode === "view" ? "View Client" : "Update Client"}
            onClose={() => {
              setClientModal(false);
              setClientModalMode("view");
            }}
            className="dialog-xxl">
            {isLoading ? (
              <LoadingScreen />
            ) : (
              <AddClients
                data={editData}
                formId={clientModalMode}
                isView={clientModalMode === "view"}
                onClose={() => {
                  setClientModal(false);
                  setClientModalMode("view");
                }}
                open={() => {
                  setClientModal(true);
                }}
                onSaveSuccess={async () => {
                  if (clientModalMode === "edit") {
                    await clientsDataGetter(currentMatterDetails?.clientId);
                    setClientModalMode("view");
                  } else {
                    setClientModal(false);
                  }
                }}
                reference={reference}
                type={clientModalMode === "view" ? "VIEW" : undefined}
              />
            )}
            <DialogActionsBar>
              <div className="dialog-footer mt-2 px-0">
                {clientModalMode === "view" ? (
                  <Button
                    type="button"
                    className="common-btn border-0 me-4"
                    onClick={() => {
                      setClientModalMode("edit");
                      dispatch(changeClientEditPermission());
                    }}
                    disabled={isLoading}>
                    Edit Client
                  </Button>
                ) : (
                  <>
                    <Button
                      type="button"
                      className="common-btn bgBtnSecondary border-0 me-2"
                      onClick={() => {
                        if (clientModalMode === "edit") {
                          setClientModalMode("view");
                        } else {
                          setClientModal(false);
                        }
                      }}>
                      Cancel
                    </Button>
                    <Button
                      className="common-btn me-4"
                      type="submit"
                      onClick={() =>
                        document.getElementById("client-submitter").click()
                      }
                      form={"edit"}
                      disabled={isLoading}>
                      {"Update Client"}
                    </Button>
                  </>
                )}
              </div>
            </DialogActionsBar>
          </Dialog>
        )}
        {showBillingGuide && (
          <BillingGuideModal
            onClose={() => setShowBillingGuide(false)}
            matterId={currentMatterDetails?.matterId}
          />
        )}
        {openEmailCompletion && (
          <EmailDialog
            title={"Email Details"}
            matterId={currentMatterDetails?.matterId}
            matter={currentMatterDetails}
            onClose={() => setOpenEmailCompletion()}
            openExistingEmailDialog={(e) => {
              setOpenExistingEmailCompletion(e);
              setOpenEmailCompletion();
            }}
          />
        )}

        {clientTask === "ID-Verification" && (
          <ClientIdVerification
            onClose={() => setClientTask()}
            matterId={currentMatterDetails?.matterId}
            client={currentMatterDetails?.client}
          />
        )}

        {showConflictCheck && (
          <Dialog
            title={"Conflict Check"}
            onClose={() => setShowConflictCheck(false)}
            className="dialog-sm"
            width={"900px"}>
            <ConflictCheck
              onClose={() => setShowConflictCheck(false)}
              onSaved={() => requestTabRefresh(TAB.ACTIVITIES)}
              fromCaseFile={true}
              matterId={currentMatterDetails?.matterId}
              currentMatterDetails={currentMatterDetails}
            />
          </Dialog>
        )}

        {openExistingEmailCompletion && (
          <EmailCompletion
            matter={currentMatterDetails}
            data={openExistingEmailCompletion}
            onClose={() => setOpenExistingEmailCompletion()}
          />
        )}

        {billingRequestMatter && (
          <BillingRequestModal
            onClose={() => {
              setBillingRequestMatter(false);
            }}
            onSubmitSuccess={() => {
              requestTabRefresh(TAB.ACTIVITIES);
            }}
            selectedMatter={billingRequestMatter}
          />
        )}
      </>
    </div>
  );
};

export default CaseFileView;
